const QUERIES = {
  USERS_LIST: 'users-list',
  PROVIDENCE: 'providence-list',
  ALLPROVIDENCE: 'all-providence-list',
  CONDITIONINGS: 'conditionings-list',
  ACTION_PLANS: 'action-plans-list',
  PROPERTY_REGISTRY: 'property-registry-list',
  LICENCES: 'licenses-list',
  LICENCES_TYPES: 'licenses-type-list',
  PRICING_TABLE: 'pricing-table-list',
  INDEMNITY_ITEMS: 'indemnity-items-list',
  INDEMNITY_AREA: 'indemnity-area-list',
  ENTERPRISES: 'enterprises-list',
  FIELDS_LINKED_ENTERPRISES: 'fields-linked-enterprises-list',
  ENTERPRISES_TYPES: 'enterprises-types-list',
  ENTERPRENEURS: 'entrepreneurs-list',
  FIELDS: 'fields-list',
  HISTORY: 'history-list',
  ISSUE_ORGANS: 'issue-organs-list',
  MEASURMENT_UNITS: 'measurment-units-list',
  PRODUCTS: 'products-list',
  COST_CENTER: 'cost-center-list',
  PROJECTS: 'projects-list',
  PROVIDERS: 'providers-list',
  RELEASES: 'releases-list',
  ROLES: 'roles-list',
  OWNERS: 'owners-list',
  PROPERTY: 'property-list',
  FIELDS_LINKED_PROPERTIES: 'fields-linked-properties-list',
  PAYMENT_HISTORY: 'payment-history-list',
  PROPERTY_PARTICIPATIONS: 'property-participations',
  LINKED_LICENCES: 'linked-licenses-list',
  FIELDS_LINKED_LICENCES: 'fields-linked-licenses-list',
  CONTRACTS: 'contracts-list',
  CONTRACTS_PAYMENT: 'contracts-payment-list',
  EVALUATION_REPORT: 'evaluation-report-list',
  PROPERTY_EVALUATION_REPORT: 'property-evaluation-report-list',
  EVALUATION_INDEMNITY_AREAS: 'evaluation-indemnity-areas-list',
  RELATED_FILES_CONTRACTS: 'related-files-contracts-list',
  RELATED_FILES_PROPERTY: 'related-files-property-list',
  RELATED_FILES_LICENSES: 'related-files-licenses-list',
  LINK_CONDITIONINGS: 'link-conditionings-list',
  PARAMETERS: 'parameters-list',
  APPLICATIONS: 'applications-list',
}

export {QUERIES}
